'use strict';

var React = require('react');
var component = require('../Text/component.js');
var index = require('../Flex/index.js');
var paginator = require('./paginator.js');
var table_styles = require('./table.styles.js');
var row = require('./row.js');
var useSelection = require('./useSelection.js');
var header = require('./Cells/header.js');
require('../Tooltip/component.js');
require('../Icon/component.js');
require('./Cells/headerIcon.styles.js');
require('./Cells/cell.js');
require('./Cells/cellCheckbox.styles.js');
require('../forms/Select/Control.js');
require('../forms/Select/Option.js');
require('./Cells/cellSelect.styles.js');
require('../forms/Switch/component.js');
require('./Cells/cellSwitch.styles.js');
require('./Cells/cellSubText.styles.js');
require('../Pill/pill.styles.js');
require('../Pill/pillButton.styles.js');
require('./Cells/cellPill.styles.js');
require('../Chip/component.js');
require('./Cells/cellChip.styles.js');
require('../Tag/component.js');
require('./Cells/cellTag.styles.js');
require('./Cells/cellActions.js');
require('./Cells/cellIcon.styles.js');
var tableData = require('./tableData.js');
var useCollapse = require('./useCollapse.js');
var useResize = require('./useResize.js');
var useExpandableRow = require('./useExpandableRow.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function IziTable({ collapseLocalStorageKey, columns, disableInitialCallback = false, engine, expandedComponent, ActionMenuLeftSlot, ActionMenuRightSlot, getRowMode, getRowOptions, id, isIconEmpty, isSmallEmpty = false, itemsPerPage = 20, labelEmptySub, labelEmptyTitle, labelSettingsCancel, labelSettingsSave, labelSettingsTitle, onFocusRow, onPageChange = () => null, sortBy, tableLayout = 'fixed', total, variant = 'body-light', withCollapse = true, withCollapsePersist = false, withSelection = false, ...props }) {
    const { colSize, setColSize, resizeMouseDown } = useResize.useResize(id, columns);
    const { columnsToShow, CollapseComponent } = useCollapse.useCollapse(id, columns, withCollapse, withCollapsePersist, collapseLocalStorageKey, labelSettingsTitle, labelSettingsSave, labelSettingsCancel);
    const showLeftActionMenu = Boolean(ActionMenuLeftSlot);
    const showRightActionMenu = Boolean(ActionMenuRightSlot || CollapseComponent);
    const showActionMenu = showLeftActionMenu || showRightActionMenu;
    const { columnsWithExpandable, colSizeWithExpandable } = useExpandableRow.useExpandableRow(engine, expandedComponent !== undefined, getRowOptions);
    const { columnsWithSelection, colSizeWithSelection, factoryHandleOnFocusRow } = useSelection.useSelection(engine, withSelection, onFocusRow);
    const columnsForTable = [...columnsWithSelection, ...columnsWithExpandable, ...columnsToShow];
    React.useEffect(() => {
        setColSize({ ...colSizeWithExpandable, ...colSizeWithSelection, ...colSize });
    }, [colSizeWithExpandable, colSizeWithSelection]);
    const handlePageChange = React.useCallback((event) => {
        const currentSkip = event.selected;
        engine.setCurrentPage(currentSkip);
        engine.setLoading(true);
        onPageChange(currentSkip, itemsPerPage);
    }, [onPageChange, itemsPerPage]);
    const setFilterActiveFactory = (cKey) => ({ filter = cKey, isInitial }) => engine.setActiveFilter(filter, isInitial);
    const [isFirstRender, setIsFirstRender] = React.useState(true);
    React.useEffect(() => {
        setIsFirstRender(false);
    }, []);
    React.useEffect(() => {
        if (!isFirstRender) {
            sortBy && sortBy(engine.state.currentSort);
        }
    }, [engine.state.currentSort]);
    return (React__default.default.createElement(component.Text, { variant: variant, as: "div" },
        showActionMenu && (React__default.default.createElement(table_styles.ActionMenuContainer, null,
            showLeftActionMenu && ActionMenuLeftSlot,
            showRightActionMenu && (React__default.default.createElement(table_styles.RightActionMenuContainer, null,
                React__default.default.createElement(index.Flex.Row, { space: "s" },
                    ActionMenuRightSlot,
                    CollapseComponent))))),
        React__default.default.createElement(table_styles.TableStyled, { id: id, tableLayout: tableLayout, "aria-busy": engine.state.isLoading, ...props },
            React__default.default.createElement("colgroup", null, columnsForTable.map(c => (React__default.default.createElement("col", { id: `${id}-col-${c.key}`, key: `${c.key}-col`, width: colSize[c.key] })))),
            React__default.default.createElement("thead", null,
                React__default.default.createElement(row.RowHeader, null, columnsForTable.map((c, i) => {
                    if (c.headerCustom) {
                        const HeaderComponent = c.headerCustom;
                        return (React__default.default.createElement(HeaderComponent, { key: `${c.key}-header`, id: `${id}-header-${c.key}`, filter: c.filter, filterKey: c.key, isFilterActive: engine.isFilterActive(c.key), setFilterActive: setFilterActiveFactory(c.key), addToCurrentSort: engine.addToCurrentSort, removeFromCurrentSort: engine.removeFromCurrentSort, initialSort: engine.getInitialSortForFilter(c.key), isFirstCol: i === 0, resize: {
                                hide: i + 1 === columnsForTable.length,
                                resizeMouseDown: resizeMouseDown(c.key),
                            } }));
                    }
                    return (React__default.default.createElement(header.Header, { key: `${c.key}-header`, id: `${id}-header-${c.key}`, filter: c.filter, filterKey: c.key, isFilterActive: engine.isFilterActive(c.key), setFilterActive: setFilterActiveFactory(c.key), addToCurrentSort: engine.addToCurrentSort, removeFromCurrentSort: engine.removeFromCurrentSort, initialSort: engine.getInitialSortForFilter(c.key), isFirstCol: i === 0, resize: {
                            hide: i + 1 === columnsForTable.length,
                            resizeMouseDown: resizeMouseDown(c.key),
                        } }, c.header));
                }))),
            React__default.default.createElement("tbody", null,
                React__default.default.createElement(tableData.TableData, { engine: engine, total: total, itemsPerPage: itemsPerPage, skip: engine.state.currentPage, columns: columnsForTable, id: id, factoryHandleOnFocusRow: factoryHandleOnFocusRow, isSmallEmpty: isSmallEmpty, labelEmptyTitle: labelEmptyTitle, labelEmptySub: labelEmptySub, getRowMode: getRowMode, expandedComponent: expandedComponent, isIconEmpty: isIconEmpty }))),
        React__default.default.createElement(paginator.Paginator, { total: total, take: itemsPerPage, skip: engine.state.currentPage, onPageChange: handlePageChange, disableInitialCallback: disableInitialCallback })));
}

exports.IziTable = IziTable;
//# sourceMappingURL=table.js.map
